import {Registered} from '@/Manager';

export class Player extends Registered {
	
	private _name: string = '';
	
	public get name(): string {
		return this._name;
	}
	
	public set name(value: string) {
		this._name = value;
	}
	
	public toJSON(): any {
		return {
			__className__: 'Player',
			name: this._name,
		};
	}
	
	public fromJSON(data: any): this {
		this._name = data.name;
		return this;
	}
	
}
